import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const formatError = (detail) => {
    if (detail == null) return "Login failed.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(detail);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back, captain.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={onSubmit} className="w-full max-w-md bg-white border border-[#E6E1D6] p-8 md:p-10" data-testid="login-form">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-10 bg-[#2D3032] text-[#F4F1EA] flex items-center justify-center">
            <Lock size={16} />
          </span>
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-[#8EAD9E]">Admin</p>
            <h1 className="font-heading text-xl text-[#2D3032]">Sign in</h1>
          </div>
        </div>
        <div className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#636769] mb-2 block">Email</label>
            <input
              type="email"
              required
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-[#E6E1D6] focus:border-[#2D3032] outline-none py-2 bg-transparent"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#636769] mb-2 block">Password</label>
            <input
              type="password"
              required
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-[#E6E1D6] focus:border-[#2D3032] outline-none py-2 bg-transparent"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={submitting}
          data-testid="login-submit-btn"
          className="mt-8 w-full bg-[#2D3032] text-white py-3 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#8EAD9E] transition-colors disabled:opacity-50"
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
